import { Button, Flex } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { DateSelector } from '../../../shared/components/DateSelector';
import { SelectAll } from '../../../../pages/insights/components/SelectAll';
import { MultipleAccountsSelector } from '../../../../pages/accounts2/components/MultipleAccountsSelector';
import { useFrameworkReporting } from '../../hooks/use-framework-reporting';
import { useOrganizationMembers } from '../../../organizations/hooks/useOrganizationMembers';

export const ReportsFilters = () => {
  const {
    frameworks,
    filterAccounts,
    filterTypes,
    filterCsms,
    filterFrameworks,
    dateOption,
    setFilterFrameworks,
    setFilterAccounts,
    setFilterCsms,
    setFilterTypes,
    resetFilters,
    handleDateOptionChanged,
    handleCalendarChange,
  } = useFrameworkReporting();

  const { members } = useOrganizationMembers();

  return (
    <Flex
      justify="space-between"
      align="center"
      gap={8}
      wrap="wrap"
      style={{
        padding: '16px',
        border: '1px solid #d9d9d9',
        borderRadius: '8px',
        marginTop: '16px',
        position: 'relative',
      }}
    >
      <label
        style={{
          position: 'absolute',
          top: -12,
          left: 12,
          background: '#F0F0F0',
          padding: '0 4px',
        }}
      >
        Filter Reports
      </label>
      <Flex gap={8} style={{ flex: 1 }} wrap="wrap">
        <div>
          <DateSelector
            defaultValues={[null, null]}
            direction="past"
            onDateOptionChanged={handleDateOptionChanged}
            onDateRangeChanged={handleCalendarChange}
            value={dateOption}
            predefinedRanges={{
              today: false,
              '1d': false,
              '7d': false,
              '12m': false,
              '30d': true,
              '60d': true,
              '90d': true,
              '120d': true,
              '3m': false,
              '6m': false,
            }}
          />
        </div>

        <SelectAll
          showAll
          style={{ width: '200px', minWidth: '200px' }}
          label={'Type'}
          value={filterTypes}
          options={[
            { id: 'scorecard', label: 'Scorecard' },
            { id: 'account', label: 'Account' },
          ]}
          onSelectionChanged={setFilterTypes}
        />

        <SelectAll
          showAll
          style={{ width: '200px', minWidth: '200px' }}
          label={'Frameworks'}
          value={filterFrameworks}
          options={frameworks?.map(f => ({ id: f.id, label: f.name })) || []}
          onSelectionChanged={setFilterFrameworks}
        />

        <MultipleAccountsSelector
          searchType="local"
          onSelect={setFilterAccounts}
          onSelectionClear={() => setFilterAccounts([])}
          value={filterAccounts}
        />

        <SelectAll
          showAll
          style={{ width: '200px', minWidth: '200px' }}
          label={'CSMs'}
          value={filterCsms}
          options={
            members?.map(member => ({
              id: member.user.id,
              label: member.user.firstName + ' ' + member.user.lastName,
            })) || []
          }
          onSelectionChanged={setFilterCsms}
        />
      </Flex>

      <Flex gap={8}>
        <Button onClick={resetFilters} icon={<ReloadOutlined />}>
          Reset Filters
        </Button>
      </Flex>
    </Flex>
  );
};
